import { render, staticRenderFns } from "./fade.vue?vue&type=template&id=56cb2a88&scoped=true"
import script from "./fade.vue?vue&type=script&lang=js"
export * from "./fade.vue?vue&type=script&lang=js"
import style0 from "./fade.vue?vue&type=style&index=0&id=56cb2a88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cb2a88",
  null
  
)

export default component.exports